import { FlexSpan, TitleText } from "@evergis/ui";
import styled from "styled-components";
import { AttributesHeader } from "../../DialogComponents/Attributes/AttributesHeader";
import { ResourceType } from "../../DialogComponents/ResourceType/ResourceType";
import { ResourceTypeIcon } from "../../DialogComponents/ResourceType/styled";
import { Image, ImageLoaderContainer, ProjectMetaBlock, Textarea } from "../../DialogComponents/styled";
import { TextInfoContainer } from "../../styled";

export const ProxyServiceResourceType = styled(ResourceType)`
  ${ResourceTypeIcon} {
    &:after {
      opacity: 0.65;
    }
  }
`;

export const ProxyLayersHeader = styled(AttributesHeader)`
  ${FlexSpan} {
    align-items: center;
  }
  ${TitleText} {
    font-size: 20px;
  }
`;

export const NameContainer = styled.div`
  width: 100%;
  position: relative;
`;

export const SystemNameText = styled.span`
  position: absolute;
  right: 8px;
  top: 0.25rem;
  color: rgba(0, 0, 0, 0.54);
  font: 400 0.75rem "Roboto", "Tahoma";
`;

export const LayerProjectMetaBlock = styled(ProjectMetaBlock)`
  min-height: 11.25rem;

  ${ImageLoaderContainer} {
    width: 11.25rem;
    height: 11.25rem;
  }

  ${Textarea} {
    min-height: 5.75rem;
  }
`;

export const ProxyServiceReadOnlyMeta = styled.div`
  ${Image} {
    width: 10.375rem;
    height: 5.625rem;
  }
  ${TextInfoContainer} {
    justify-content: center;
  }
`;

export const LabelWrapper = styled.div`
  position: relative;
`;

export const LabelContainer = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  white-space: nowrap;
  top: -1.25rem;
  left: 1rem;
`;
